export enum AssociatedEntityTypes {
  account = 'account',
  netSuiteId = 'NetsuiteId',
  jskBillingAccount = 'JskBillingAccount',
  location = 'Location',
  featuredAd = 'FeaturedAd',
}
